import {IEnvironment} from '../app/0-application/types'

export const environment: IEnvironment = {
  production: false,
  domain: 'profit-hunger.internal.sparbankensyd.se',
  authServiceUrl: 'https://lk.internal.sparbankensyd.se/service',
  apiUrl: 'https://lk.internal.sparbankensyd.se/api',
  interestsUrl: 'https://lk.internal.sparbankensyd.se/interests',
  borgoUrl: 'https://lk.internal.sparbankensyd.se/borgo',
}